import { Component, Input } from '@angular/core';

@Component({
  selector: 'cargoes-form-value-kenya',
  template: `
    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div nz-row>
        <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" nzXs="24" class="bold">
          <span [translate]="label"></span>
        </div>
        <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" nzXs="24">
          {{value}}
        </div>
      </div>
    </div>
  `,
  styles: [
    '.bold { font-weight: bold; }',
    '.text-wrap { white-space: nowrap; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }'
  ]
})
export class FormValueKenyaComponent {
  @Input() label!: string;
  @Input() value!: any;
}